import { OrbType, OrbDef, ORB_DEFS } from '@/lib/arcane-blitz-engine';

interface ArcanePowerOrbProps {
  type: OrbType;
  /** Size in pixels of the orb dot */
  size?: 'sm' | 'md';
}

const ORB_STYLES: Record<OrbType, { bg: string; shadow: string }> = {
  'mana-gem':      { bg: 'bg-teen-cyan',   shadow: 'shadow-[0_0_8px_hsl(var(--teen-cyan)/0.8)]' },
  'speed-rune':    { bg: 'bg-teen-gold',   shadow: 'shadow-[0_0_8px_hsl(var(--teen-gold)/0.8)]' },
  'berserker-rune':{ bg: 'bg-teen-red',    shadow: 'shadow-[0_0_8px_hsl(var(--teen-red)/0.8)]' },
  'fortify-rune':  { bg: 'bg-teen-green',  shadow: 'shadow-[0_0_8px_hsl(var(--teen-green)/0.8)]' },
};

export function ArcanePowerOrb({ type, size = 'md' }: ArcanePowerOrbProps) {
  const def = ORB_DEFS.find(d => d.type === type)!;
  const style = ORB_STYLES[type];
  const sizeClass = size === 'sm' ? 'w-3 h-3 text-[9px]' : 'w-5 h-5 text-xs';

  return (
    <div
      className={`
        ${sizeClass} rounded-full ${style.bg} ${style.shadow}
        flex items-center justify-center
        animate-sparkle pointer-events-none
        border border-white/30
      `}
      title={`${def.name}: ${def.description}`}
    >
      <span className="leading-none select-none">{def.emoji}</span>
    </div>
  );
}
